webpackJsonp([169467334331038],{

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageTitle = /*#__PURE__*/(0, _reactEmotion2.default)('h2', {
	  target: 'css-hghm6m0'
	})('font-size:22px;font-family:\'Sonsie One\',cursive;');
	
	var PageBody = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'css-hghm6m1'
	})('padding:20px;flex-grow:1;');
	
	var Breadcrumb = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'css-hghm6m2'
	})('font-size:.8rem;margin-bottom:.25rem;& a{text-decoration:none;color:#000;&::after{content:"\0BB";font-size:1rem;margin-left:5px;}}');
	var PageLinks = /*#__PURE__*/(0, _reactEmotion2.default)('ul', {
	  target: 'css-hghm6m3'
	})('display:flex;flex-direction:row;justify-content:space-between;align-items:"flex-start";margin-left:0;padding:20px;list-style-type:none;margin-bottom:0;& li{margin-bottom:0;display:inline-block;}& span{padding:10px;}& a{text-decoration:none;color:#222;background-color:#e3cf34;padding:10px;border-radius:10px;display:block;& i{font-size:.7em;}}');
	
	var PageComponent = function PageComponent(props) {
	  var _props$data = props.data,
	      nextPage = _props$data.nextPage,
	      prevPage = _props$data.prevPage,
	      page = _props$data.page;
	
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      PageBody,
	      null,
	      _react2.default.createElement(
	        Breadcrumb,
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' + props.data.page.chapter.slug + '/' },
	          props.data.page.chapter.title
	        )
	      ),
	      _react2.default.createElement(
	        PageTitle,
	        null,
	        page ? page.title : null
	      ),
	      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: props.data.page.body.childMarkdownRemark.html } })
	    ),
	    _react2.default.createElement(
	      PageLinks,
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        prevPage != null ? _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' + page.chapter.slug + '/' + prevPage.path + '/' },
	          _react2.default.createElement('i', { className: 'icon-277' }),
	          ' ',
	          prevPage.title
	        ) : _react2.default.createElement(
	          'span',
	          null,
	          '\xA0'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        nextPage != null ? _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' + page.chapter.slug + '/' + nextPage.path + '/' },
	          nextPage.title,
	          ' ',
	          _react2.default.createElement('i', { className: 'icon-276' })
	        ) : ""
	      )
	    )
	  );
	};
	
	exports.default = PageComponent;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-components-page-js-e8070efe95d50f21b1d5.js